

class Comando {
    constructor({
      id = null,
      equipo = '',
  
      comando = '',
      empleado = '',
      usuario = '',
    creado_en = '',
    
    }) {
      this.id = id;
      this.equipo = equipo;
    
      this.comando = comando;
      this.empleado = empleado;
      this.usuario = usuario;
     this.creado_en = creado_en;
    }
  
    // Método para actualizar los datos de la empresa
    update(data) {
      Object.assign(this, data);
    }
  }
  
  export default Comando;